module.exports = __webpack_public_path__ + "source/img/thumb-down-line.4b762dda.svg";